var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PAUSE ICON Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "100---MODAL---Video-Playback",
    transform: "translate(-167.000000, -569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PAUSE-ICON-Copy",
    transform: "translate(167.661290, 569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#1D1183"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.8387097,
    cy: 20,
    rx: 19.8387097,
    ry: 20
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 12.3387097,
    y: 12,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 22.3387097,
    y: 12,
    width: 4,
    height: 16
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.6afcfd4c6c9a551a3f04ddf496e99511.svg";
export { ForwardRef as ReactComponent };